import React, { useEffect, useState } from 'react';
import BACK from '../images/icon-back-b.svg';
import SensorCreateModal from '../Components/SensorAdmin/SensorCreateModal';
import SensorEditModal from '../Components/SensorAdmin/SensorEditModal';
import axios from 'axios';
import HEADER from "../Components/header";
import { useNavigate } from 'react-router-dom'
import { useForm, SubmitHandler } from 'react-hook-form';
import { useCookies } from 'react-cookie';
import baseUrlApi from '../lib/baseUrlApi';
import SensorKindConsts from "../Consts/SensorKinds";
import {ApiRequest} from "../Consts/ApiRequest";

type sensorAdminInputs = {
    sensorID: string;
    sensorName: string;
    sensorKind: number;
    sensorRecno: string;
};
const SensorAdmin = () => {
    const navigate = useNavigate();
    const [sensorAdminData, setSensorAdminData] = useState<sensorAdminInputs[]>([]);
    const [sensorID, setSensorID] = useState<string>("");
    const [sensorName, setSensorName] = useState<string>("");
    const [sensorKind, setSensorKind] = useState<number>(0);
    const [ loading, setLoading ] = useState(true);
    const [sensorRecno, setSensorRecno] = useState<string>("");
    const [selectedSensorKind, setSelectedSensorKind] = useState<string>("");
    const { register, handleSubmit, formState: { errors } } = useForm<sensorAdminInputs>();
    const [cookies, setCookie, removeCookie] = useCookies(['authority', 'access_token', "siteId", "siteRecno"]);

    function errorCallback(error:any){
        if (error.response && error.response.status === 401) {
            console.error("Error token error:", error);
            removeCookie('access_token', {path: '/'});
            removeCookie('authority', {path: '/'});
            removeCookie('siteId', {path: '/'});
            removeCookie('siteRecno', {path: '/'});
            navigate("logout");
        }
        console.error("Error fetching dataSite:", error);
    }

    /***
     * センサーのフィルタリング
     * @param argSensorKind
     */
    function filterSensor(argSensorKind: number) {

        let result = sensorAdminData.filter(item => {
            if (argSensorKind == 0) {
                return true;
            }
            return item.sensorKind == argSensorKind;
        });
    }
    // センサー種別のリンクをクリックしたときのハンドラ

    const handleSensorKindClick = (argSensorKind: number) => {
        setTimeout(function (){
            setSensorKind(argSensorKind);
            filterSensor(argSensorKind);
        }, 0);
    };

    const [state, setState] = useState("aaaaaaaa")
    const changeState = (isState: string) => {
        setState(isState)
        getSensor();
    }

    useEffect(() => {
        if(cookies.authority == 2 || cookies.authority == 3 || cookies.authority == 4) {
            removeCookie('access_token', {path: '/'});
            removeCookie('authority', {path: '/'});
            removeCookie('siteId', {path: '/'});
            removeCookie('siteRecno', {path: '/'});
            navigate("logout");
        }
        if (!loading) {
            return;
        }
        setLoading(false)
        getSensor();
    }, []);


    const getSensor = async () => {
        let params = {
            "prcKind": 0,
        }
        const token = cookies.access_token || "";
        ApiRequest.getSensor(
            params,
            token,
            (response:any) => {
                setSensorAdminData(response.data.sensors);
            }, (error:any) => {
                errorCallback(error);
            }
        )
    }

    const getSensors = function(){
        let params = {
            "sensorInfo": {
                "sensorID": sensorID,
                "sensorName": sensorName,
                "sensorKind": selectedSensorKind,
                "sensorRecno": sensorRecno
            },
            "prcKind": 0
        };
        const token = cookies.access_token || "";
        ApiRequest.getSensor(params, token, (response: any)=> {
            console.log(response);
            setSensorAdminData(response.data.sensors);
        }, (error:any)=> {
            console.error("Error fetching data:", error);
            errorCallback(error);
        });
    }

    useEffect(() => {
        // すでに初期化されていたら処理を抜ける
        setLoading(false);
        getSensors();
    }, [loading]);

    const onSubmitSearch: SubmitHandler<sensorAdminInputs> = async (data) => {
        setSensorAdminData([]);
        try {
            let params = {
                "sensorInfo": {
                    "sensorID": sensorID,
                    "sensorName": sensorName,
                    "sensorKind": 0
                },
                "prcKind": 1
            };
            const token = cookies.access_token || "";
            ApiRequest.getSensor(params, token,(response:any) => {
                console.log(response);
                if (Array.isArray(response.data.sensors)) {
                    setSensorAdminData(response.data.sensors);
                }
            }, (error:any) => {
                errorCallback(error);
            });
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    return (
        <>
            <div className="wrapper">
                <HEADER />
                <main className="main">
                    <section className="page-head" id="page-head">
                        <div className="page-head-block">
                            <div className="page-name">
                                <a onClick={() => navigate(-1)}><img src="https://www.sooki-cloud-portalsystem.jp/static/media/icon-back-b.a302f48a196965a4ff8d4568031a609b.svg" alt="戻る" /></a>
                                <div className="page-name-label">センサ管理画面</div>
                            </div>
                            <div className="page-option">
                                <SensorCreateModal
                                    setState={changeState}
                                />
                            </div>
                        </div>
                        <div className="page-head-block">
                            <ul className="page-tabs">
                                <li className={sensorKind == 0? "active": ""}>
                                    <a onClick={() => handleSensorKindClick(0)}>すべて</a>
                                </li>
                                <li className={sensorKind == 3? "active": ""}>
                                    <a onClick={() => handleSensorKindClick(3)}>騒音振動</a></li>
                                <li className={sensorKind == 2? "active": ""}>
                                    <a onClick={() => handleSensorKindClick(2)}>気象</a></li>
                                <li className={sensorKind == 1? "active": ""}>
                                    <a onClick={() => handleSensorKindClick(1)}>水位</a></li>
                            </ul>
                        </div>
                    </section>
                    <section className="page-body scroll-block">
                        <form onSubmit={handleSubmit(onSubmitSearch)}>
                            <div className="search-box">
                                <div className="search-box-elm">
                                    <div className="search-box-elm-name">センサ管理番号</div>
                                    <div className="search-box-elm-input">
                                        <input
                                            type="text"
                                            value={sensorID}
                                            placeholder="sensorID"
                                            {...register("sensorID")}
                                            className={"col-320 " + (errors.sensorID ? "error-disp" : "")}
                                            onChange={e => setSensorID(e.target.value)}
                                        />
                                        {errors.sensorID && <p className="error-msg">{errors.sensorID.message}</p>}
                                    </div>
                                </div>
                                <div className="search-box-elm">
                                    <div className="search-box-elm-name">センサ名</div>
                                    <div className="search-box-elm-input">
                                        <input
                                            type="text"
                                            value={sensorName}
                                            placeholder="sensorName"
                                            {...register("sensorName")}
                                            className={"col-320 " + (errors.sensorName ? "error-disp" : "")}
                                            onChange={e => setSensorName(e.target.value)}
                                        />
                                        {errors.sensorName && <p className="error-msg">{errors.sensorName.message}</p>}
                                    </div>
                                </div>
                                <div className="search-box-btn">
                                    <button className="btn btn-white-line"><i className="icon-search-w"></i>検索</button>
                                </div>
                            </div>
                        </form>

                        <div className="table-box">
                            <table className="st-table">
                                <thead>
                                    <tr>
                                        <th className="">センサ管理番号</th>
                                        <th className="">センサ名</th>
                                        <th className="">センサ種別</th>
                                        <th className="col-100">編集</th>
                                    </tr>
                                </thead>
                                <tbody>

                                {sensorAdminData.filter((item) => {
                                    if(sensorKind == 0) return true;
                                    return item.sensorKind == sensorKind;
                                }).map((item, index) => (
                                        <tr className={"sensor_kind_" + item.sensorKind} key={item.sensorID}>
                                            <td className="nowrap">{item.sensorID}</td>
                                            <td className="nowrap">{item.sensorName}</td>
                                            <td className="nowrap">{SensorKindConsts.getKind(item.sensorKind)}</td>
                                            <td>
                                                <SensorEditModal sensorID={item.sensorID}
                                                    sensorKind={Number(item.sensorKind)}
                                                    sensorName={item.sensorName}
                                                    sensorRecno={item.sensorRecno}
                                                    setState={changeState}
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </section>
                </main>
            </div>
        </>
    )
};
export default SensorAdmin;
